import { arrayOf, number, string, shape } from 'prop-types';
import salesTypes from './salesTypes';

export const country = shape({
  salesType: salesTypes,
  rtd: number,
  twtd: number,
  lwtd: number,
  rtdOfGlobal: number,
  twtdOfGlobal: number,
  wowInProgress: number,
  countryRank: number,
});

export default arrayOf(
  shape({
    countryId: string,
    countryName: string,
    data: arrayOf(country),
  })
);
